var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from "react";
import styled from "styled-components";
import { classnames } from "../../../utils";
import { Modal } from "../../Modal";
import { DialogSeparator } from "../DialogSeparator";
import { DialogHeader } from "../DialogHeader";
import { DialogContent } from "../DialogContent";
import { DialogFooter } from "../DialogFooter";
var DialogModal = styled(Modal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 588px;\n"], ["\n  width: 588px;\n"])));
var Dialog = function (_a) {
    var id = _a.id, className = _a.className, style = _a.style, isOpen = _a.isOpen, title = _a.title, acceptButtonText = _a.acceptButtonText, closeButtonText = _a.closeButtonText, _b = _a.acceptDisabled, acceptDisabled = _b === void 0 ? false : _b, children = _a.children, onAccept = _a.onAccept, onClose = _a.onClose, showDialogCloseIcon = _a.showDialogCloseIcon;
    return (React.createElement(DialogModal, { id: id, className: classnames(className, "bn-dialog"), style: style, isOpen: isOpen, onRequestClose: onClose },
        React.createElement(DialogHeader, { title: title, onClose: onClose, showCloseIcon: showDialogCloseIcon }),
        React.createElement(DialogSeparator, null),
        React.createElement(DialogContent, null, children),
        React.createElement(DialogSeparator, null),
        React.createElement(DialogFooter, { acceptButtonText: acceptButtonText, closeButtonText: closeButtonText, acceptDisabled: acceptDisabled, onAccept: onAccept, onClose: onClose })));
};
Dialog.defaultProps = {
    showDialogCloseIcon: true
};
export default Dialog;
var templateObject_1;
//# sourceMappingURL=Dialog.js.map